const GroupTeam = ({title, addGroupTeam}) => {
    return (
        <>
            <div className="card">
                <div className="card-header">
                    <h3 className="card-title">
                        <i className="ion ion-clipboard mr-1"></i>
                        {title}
                    </h3>
                </div>
                <div className="card-body">
                    <ul className="todo-list" data-widget="todo-list">

                    </ul>
                </div>
                <div className="card-footer clearfix">
                    <button type="button" className="btn btn-success float-right" onClick={addGroupTeam}><i className="fas fa-plus"></i> Add
                        team
                    </button>
                </div>
            </div>
        </>
    );
}

export default GroupTeam;